import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import ApiPageSpecificFaq from "@/api/ApiPageSpecificFaq";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import dayjs from "dayjs";
import CKEditorConfig from "@/data/CKeditor/config";
let EditPageSpecificQuestion = class EditPageSpecificQuestion extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.editorConfig = CKEditorConfig.editorConfig(ApiEnter.CurrentSessionUUID);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Home",
            },
            {
                to: "/page-specific-faq",
                exact: true,
                text: "Page specific FAQ",
            },
            {
                text: "Questions",
                disabled: true,
            },
        ];
        this.HasLoading = false;
        this.FaqUrls = [];
        this.currentFaq = {
            answer: "",
            question: "",
            publish: true,
            priority: "",
            url: "",
            created: "",
        };
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const response = await ApiPageSpecificFaq.UpdateFaqInfo(this.currentFaq.answer, this.currentFaq.question, this.currentFaq.priority, this.currentFaq.publish ? 1 : 0, this.currentFaq.url, ApiEnter.CurrentSessionUUID, this.CurrentFaqUUID);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.$forceUpdate();
                    this.currentFaq.answer = "";
                    this.currentFaq.question = "";
                    this.currentFaq.priority = "";
                    this.currentFaq.publish = true;
                    this.currentFaq.url = "";
                    this.currentFaq.created = "";
                    this.$router.push(`/page-specific-faq`);
                });
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        this.HasLoading = false;
    }
    async GetFaqInfo() {
        const faqInfo = await ApiPageSpecificFaq.GetFaqByUUID(ApiEnter.CurrentSessionUUID, this.CurrentFaqUUID);
        if (faqInfo == undefined) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            }).then(() => {
                this.$router.push("/");
            });
            return;
        }
        this.currentFaq.answer = faqInfo.answer;
        this.currentFaq.question = faqInfo.question;
        this.currentFaq.publish = faqInfo.publish;
        this.currentFaq.priority = faqInfo.priority;
        this.currentFaq.created = dayjs.tz(faqInfo.create_at, "Europe/Rome").format("DD.MM.YYYY HH:mm");
        this.currentFaq.url = faqInfo.url;
    }
    async GetFaqUrls() {
        try {
            this.FaqUrls = await ApiPageSpecificFaq.GetFaqUrls(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    mounted() {
        this.CurrentFaqUUID = this.$route.params.faq_uuid;
        this.GetFaqUrls();
        this.GetFaqInfo();
    }
};
EditPageSpecificQuestion = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, CKEditor },
    })
], EditPageSpecificQuestion);
export default EditPageSpecificQuestion;
